<template>
<div>
    <Breadcrumbs main="HR" :title="`Attendance - ${monthName}`" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                       
                        <b-row>
                            <b-col xl="6">
                                <div style="display: flex; gap: 8px;">
                                    <div class="d-flex flex-wrap" style="gap: 20px;">
                                        <b-input-group class="datatable-btn" style="width: 340px;">
                                            <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                            <b-input-group-append>
                                                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </div>
                                    <div style="padding-top: 2px;">
                                        <a :href="`https://api-bnps.smicee.com/api/access-control/user-accounts/time-sheet/monthly-summary/csv?start_date=${startDate}&end_date=${endDate}`" rel="noopener noreferrer">
                                            <button class="btn btn-primary">Download CSV</button>
                                        </a>
                                    </div>
                                </div>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div class="row mt-2">
                            <div class="col-md-12">
                                <div class="grid-container mt-sm-0">
                                    <div class="grid-item col-md-8 col-lg-6">
                                        <div style="display: flex; flex-direction: row; align-items: center; gap: 8px; margin-left: -12px;">
                                            <h6 class="mt-2 mt-lg-1">Month:</h6>
                                            <b-form-select v-model="monthSelected" :options="formattedMonths" @change="onMonthChange" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue" style="margin-top: 22px;">
                                <b-table show-empty stacked="md" :items="tableRows" :fields="tableFields" :per-page="perPage">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(employee)="data">
                                        <div style="min-width: 200px;">
                                            <router-link :to="`/hr/time-sheet/${data.item.employee.id}`" class="link-style">
                                                <strong>{{ data.item.employee.name }}</strong>
                                            </router-link><br />
                                            <small class="text-muted">{{ data.item.employee.email }}</small>
                                        </div>
                                    </template>

                                    <template #cell(present)="data">
                                        <span class="text-primary fw-bold">{{ data.item.present }} / {{ selectedMonthDays }}</span>
                                    </template>

                                    <template v-for="date in allDates" v-slot:[`cell(${date})`]="data">
                                    
                                        <div style="min-width: 120px;">
                                            <span :class="data.item[date]?.present ? 'text-success' : 'text-danger'">
                                                {{ data.item[date]?.present ? '✔' : '✘' }}
                                            </span>
                                            <div class="d-flex flex-column" v-if="data.item[date]?.present">
                                                <h7>In: {{ formatTo12Hour(data.item[date].punched_in) }}</h7>
                                                <h7>Out: {{ formatTo12Hour(data.item[date].punched_out) }}</h7>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- <template v-for="date in allDates" v-slot:[`cell(${date})`]="data">
  <div 
    :class="[{ 'bg-danger text-white': isHoliday(date) }]" 
    style="min-width: 120px; height: 100%;"
  >
    <span :class="data.item[date]?.present ? 'text-success' : 'text-danger'">
      {{ data.item[date]?.present ? '✔' : '✘' }}
    </span>
    <div class="d-flex flex-column" v-if="data.item[date]?.present">
      <h7>In: {{ formatTo12Hour(data.item[date].punched_in) }}</h7>
      <h7>Out: {{ formatTo12Hour(data.item[date].punched_out) }}</h7>
    </div>
  </div>
</template> -->

                                    <!-- <template v-for="date in allDates" v-slot:[`cell(${date})`]="data">
                                        <div style="min-width: 120px;">
                                            <span :class="getCellClass(data.item[date].present)">
                                                {{ data.item[date].present ? '✔' : '✘' }}
                                            </span>
                                            <div class="d-flex flex-column" v-if="data.item[date].present">
                                                <h7>In: {{ formatTo12Hour(data.item[date].punched_in) }}</h7>
                                                <h7>Out: {{ formatTo12Hour(data.item[date].punched_out) }}</h7>

                                            </div>
                                        </div>
                                    </template> -->

                                    <template #cell(status)="row">
                                        <span v-if="row.value == 'IN'">
                                            <b-badge pill variant="success">{{ row.value }}</b-badge>
                                        </span>
                                        <span v-if="row.value == 'OUT'">
                                            <b-badge pill variant="warning">{{ row.value }}</b-badge>
                                        </span>
                                        <span v-if="row.value == 'absent'">
                                            <b-badge pill variant="danger" class="text-uppercase">{{ row.value }}</b-badge>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>
                        <div v-else>
                            <div class="loader-box">
                                <div class="loader-10"></div>
                            </div>
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import Datepicker from 'vuejs-datepicker';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import moment from "moment";

export default {
    components: {
        Datepicker
    },

    data() {
        return {
            filterShow: false,
            filter: null,
            statusSelected: '',
            monthSelected: new Date().getMonth(),
            monthName: '',
            startDate: '',
            endDate: '',
            selectedDepartment: '',
            selectedDesignation: '',
            selectedEmployee: '',
            formattedMonths: [{
                    value: null,
                    text: 'Select a month'
                },
                {
                    value: 0,
                    text: 'January'
                },
                {
                    value: 1,
                    text: 'February'
                },
                {
                    value: 2,
                    text: 'March'
                },
                {
                    value: 3,
                    text: 'April'
                },
                {
                    value: 4,
                    text: 'May'
                },
                {
                    value: 5,
                    text: 'June'
                },
                {
                    value: 6,
                    text: 'July'
                },
                {
                    value: 7,
                    text: 'August'
                },
                {
                    value: 8,
                    text: 'September'
                },
                {
                    value: 9,
                    text: 'October'
                },
                {
                    value: 10,
                    text: 'November'
                },
                {
                    value: 11,
                    text: 'December'
                }
            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 5,
            pageOptions: [5, 10, 25, 50, 100],
            statuses: [{
                    id: 1,
                    name: 'In',
                    value: 'IN'
                },
                {
                    id: 2,
                    name: 'Out',
                    value: 'OUT'
                }
            ],
            initialLoad: true,
        };
    },

    computed: {
        ...mapState({
            setting: state => state.organization.organization_setting,
            attendances: state => state.punch.attendances,
            count: state => state.punch.attendance_count,
            loading: state => state.punch.submitLoading,
            error: state => state.punch.submitError
        }),

        allDates() {
            const dateSet = new Set();
            this.attendances.forEach(user =>
                user.attendance.forEach(a => dateSet.add(a.date))
            );
            console.log(...dateSet)
            return [...dateSet].sort();
        },

        selectedMonthDays() {
            const dateSet = new Set();

            this.attendances.forEach(user => {
                user.attendance.forEach(a => {
                    const [year, month, day] = a.date.split('-');
                    const key = `${year}-${month}-${day}`; // full date to count
                    dateSet.add(key);
                });
            });

            return dateSet.size; // number of unique days in that month
        },

        tableFields() {
  const today = new Date().toISOString().split('T')[0]; // "YYYY-MM-DD"

  return [
    {
      key: 'sl',
      label: '#'
    },
    {
      key: 'employee',
      label: 'Employee'
    },
    {
      key: 'present',
      label: 'Present'
    },
    ...this.allDates.map(date => {
      let thStyle = {};
      let tdStyle = {};

      if (this.isHoliday(date)) {
        thStyle = { backgroundColor: '#ffcccc', color: '#000000' }; 
        // tdStyle = { backgroundColor: '#fff444', color: '#000000' };
      }

      if (date === today) {
        thStyle = { backgroundColor: '#80B370', color: '#ffffff' }; 
        // tdStyle = { backgroundColor: '#cce5ff', color: '#000000' };
      }

      return {
        key: date,
        label: date,
        thStyle,
        tdStyle
      };
    })
  ];
},

        tableRows() {
            return this.attendances.map((user, index) => {
                const row = {
                    '#': (this.currentPage - 1) * this.perPage + index + 1,
                    employee: {
                        id: user.user_id.id,
                        name: user.user_id.full_name,
                        email: user.user_id.email
                    },
                    present: user.attendance.filter(a => a.present).length
                };

                user.attendance.forEach(entry => {
                    if (entry.date) {
                        const dateObj = new Date(entry.date);
                        const day = dateObj.getDay(); // 0=Sun ... 6=Sat

                        // check if it's holiday
                        const isHoliday = this.setting.holidays.some(s => s.value === day);

                        row[entry.date] = {
                            ...entry,
                            isHoliday
                        };
                    }
                });

                return row;
            });
        },

    

        formattedOptions() {
            return [{
                    value: '',
                    text: 'Select Status',
                    disabled: true
                },
                ...this.statuses.map(status => ({
                    value: status.value,
                    text: status.name
                }))
            ];
        },

        formattedEmployee() {
            return [{
                    value: '',
                    text: 'Select Employee',
                    disabled: true
                },
                ...this.employee_list.map(emp => ({
                    value: emp.id,
                    text: emp.full_name
                }))
            ];
        },

        formattedDesignation() {
            return [{
                    value: '',
                    text: 'Select Designation',
                    disabled: true
                },
                ...this.designation_list.map(desg => ({
                    value: desg.id,
                    text: desg.title
                }))
            ];
        },

        formattedDepartment() {
            return [{
                    value: '',
                    text: 'Select Department',
                    disabled: true
                },
                ...this.department_list.map(dept => ({
                    value: dept.id,
                    text: dept.name
                }))
            ];
        }
    },

    mounted() {
        this.$store.dispatch("organization/fetchOrganizationSettings")
        this.onMonthChange();

        if (this.initialLoad) {
            if (!this.$route.query.page || !this.$route.query.perPage) {
                this.$router.replace({
                    path: this.$route.path,
                    query: {
                        page: this.currentPage,
                        perPage: this.perPage
                    }
                }).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        throw err;
                    }
                });
                this.fetchInitial();
            } else {
                this.currentPage = parseInt(this.$route.query.page);
                this.perPage = parseInt(this.$route.query.perPage);
                this.fetchInitial();
            }
        }
    },

    watch: {
        currentPage(newCurrentPage) {
            if (!this.initialLoad) {
                this.$router.replace({
                    path: '/hr/attendance',
                    query: {
                        page: newCurrentPage,
                        perPage: this.perPage
                    },
                });
                this.currentPage = newCurrentPage
                this.$store.dispatch("punch/fetchAttendances", {
                    perPage: this.perPage,
                    currentPage: newCurrentPage,
                    search_term: this.filter,
                    start_date: this.startDate,
                    end_date: this.endDate
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false
                });
            }
        },

        perPage(newperPage) {
            if (!this.initialLoad) {
                this.$router.replace({
                    path: '/hr/attendance',
                    query: {
                        page: this.currentPage,
                        perPage: newperPage
                    },
                });
                this.perPage = newperPage
                this.$store.dispatch("punch/fetchAttendances", {
                    perPage: newperPage,
                    currentPage: this.currentPage,
                    search_term: this.filter,
                    start_date: this.startDate,
                    end_date: this.endDate
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false
                });
            }
        },

        filter(newVal, oldVal) {
            if (!this.initialLoad) {
                this.$store.dispatch("punch/fetchAttendances", {
                    perPage: this.perPage,
                    currentPage: 1,
                    status: this.statusSelected,
                    search_term: this.filter,
                    start_date: this.startDate,
                    end_date: this.endDate
                }).then(() => {
                    this.items = this.attendances
                    this.totalRows = this.count;
                    this.initialLoad = false
                });
            }
        },

        startDate(newVal, oldVal) {
            if (!this.initialLoad) {
                this.$store.dispatch("punch/fetchAttendances", {
                    perPage: this.perPage,
                    currentPage: 1,
                    status: this.statusSelected,
                    search_term: this.filter,
                    start_date: this.startDate,
                    end_date: this.endDate
                }).then(() => {
                    this.items = this.attendances
                    this.totalRows = this.count;
                    this.initialLoad = false
                });
            }
        }
    },

    methods: {
        formatTo12Hour(datetime) {
            // Handle null/undefined
            if (!datetime) return "-";

            const date = new Date(datetime);
            if (isNaN(date.getTime())) return "-"; // invalid date

            let hours = date.getHours(); // 0-23
            const minutes = date.getMinutes(); // 0-59
            const ampm = hours >= 12 ? "PM" : "AM";

            hours = hours % 12 || 12; // convert 0 => 12, 13 => 1, etc.
            const paddedMinutes = minutes.toString().padStart(2, "0");

            return `${hours}:${paddedMinutes} ${ampm}`;
        },
        formatDayOnly(dateStr) {
            return dateStr.split('-')[2];
        },
        isHoliday(date) {
            const day = new Date(date).getDay(); // 0=Sun ... 6=Sat
            return this.setting.holidays.some(s => s.value === day);
        },
        getCellClass(present, date) {
            if (this.isHoliday(date)) {
                return 'bg-danger text-white'; // bootstrap red
            }
            return present ? 'text-success' : 'text-danger';
        },

        onMonthChange() {
            if (this.monthSelected === null || isNaN(this.monthSelected)) {
                this.startDate = '';
                this.endDate = '';
                this.monthName = '';
                return;
            }

            const year = new Date().getFullYear();
            const month = Number(this.monthSelected);

            const start = new Date(year, month, 1);
            const end = new Date(year, month + 1, 0);

            const format = (date) => {
                const yyyy = date.getFullYear();
                const mm = String(date.getMonth() + 1).padStart(2, '0');
                const dd = String(date.getDate()).padStart(2, '0');
                return `${yyyy}-${mm}-${dd}`;
            };

            this.startDate = format(start);
            this.endDate = format(end);

            // Get the name of the selected month
            const selected = this.formattedMonths.find(opt => opt.value === month);
            this.monthName = selected ? selected.text : '';
        },

        fetchInitial() {
            this.$store.dispatch("punch/fetchAttendances", {
                perPage: this.perPage,
                currentPage: this.currentPage,
                start_date: this.startDate,
                end_date: this.endDate,
                search_term: this.filter
            }).then(() => {
                this.totalRows = this.count;
                this.initialLoad = false;
            });
        }
    }
};
</script>
